// Add your custom JS here.

document.addEventListener('DOMContentLoaded', function() {

    if (document.getElementsByClassName('splide_slider').length>0)
    {
        
        var splide_slider = new Splide('.splide.splide_slider', {
            type: 'fade',
            autoplay: true,
            interval: 4000,
            focus: false,
            pagination: false,
            rewind: true,
            perPage: 1,
            height: '94vh',
        });


        var splide_boxetti = new Splide('.splide.splide_boxetti', {
            type: 'loop',
            autoplay: true,
            interval: 4000,
            pagination: false,
            arrows: false,
            rewind: true,
            perPage: 3,
            direction: 'ttb',
            height: '50vh',
            isNavigation: true,
            gap: 8,
            wheel: true,
        });


        const width = window.innerWidth;
        const height = window.innerHeight;
        
        splide_slider.sync(splide_boxetti);
        splide_slider.mount();
        splide_boxetti.mount();	

        var contenitore_boxetti = document.getElementById("contenitore_boxetti");
        
        if (width > 992) {
            contenitore_boxetti.style.display = "flex";

        } else {

            contenitore_boxetti.style.display = "none";

        }



        window.addEventListener("resize", () => cambia_slide());
        screen.orientation.addEventListener("change", (event) => cambia_slide());

        function cambia_slide() {
            const width = window.innerWidth;
            const height = window.innerHeight;
            var contenitore_boxetti = document.getElementById("contenitore_boxetti");

            if (width > 992) {
                contenitore_boxetti.style.display = "flex";

            } else {

                contenitore_boxetti.style.display = "none";

            }

        }
        
    }
    
    if (document.getElementsByClassName('splide_news').length>0)
    {
        var splide_news = new Splide('.splide.splide_news', {
            type: 'loop',
            autoplay: false,
            interval: 4000,
            focus: true,
            gap: 20,
            pagination: false,
            padding: {
                left: 0,
                right: 68
            },
            perPage: 3,
            breakpoints: {
                767: {
                    perPage: 1,
                    padding: {
                        left: 0,
                        right: 40
                    },
                },
                1200: {
                    perPage: 2,
                    padding: {
                        left: 0,
                        right: 20
                    },
                },
            }


        });
        splide_news.mount();
        
    }

    if (document.getElementsByClassName('splide_media').length>0)
    {
        var splide_media = new Splide('.splide.splide_media', {
            type: 'loop',
            autoplay: false,
            interval: 4000,
            focus: true,
            gap: 20,
            pagination: false,
            padding: {
                left: 0,
                right: 68
            },
            perPage: 3,
            breakpoints: {
                767: {
                    perPage: 1,
                    padding: {
                        left: 0,
                        right: 40
                    },
                },
                1200: {
                    perPage: 2,
                    padding: {
                        left: 0,
                        right: 20
                    },
                },
            }


        });
        splide_media.mount();
        
    }

	var elms = document.getElementsByClassName( 'splide_gallery' );
    if (document.getElementsByClassName('splide_gallery').length>0)
    {
        for ( var i = 0; i < elms.length; i++ ) {
            
            var splide_gallery = new Splide(elms[i], {
                type: 'loop',
                autoplay: true,
                interval: 3000,
                pagination: false,
                perPage: 1,
                gap:1,


            });
            splide_gallery.mount();
        }	
        
    }
    
    const lightbox = GLightbox();

    const lightbox1 = GLightbox({selector:'.post_content .wp-block-image figure a'});
	
	const lightbox2 = GLightbox({selector:'.post_content figure a'});
    
    if (document.getElementById('sharebutton')!=null)
    {
        var popover = new understrap.Popover(document.getElementById('sharebutton'));
        

        const sharebutton = document.getElementById('sharebutton')
        sharebutton.addEventListener('inserted.bs.popover', () => {
            const fb = document.getElementById('fb');
            fb.addEventListener('click', shareOnFacebook);

            const tweet = document.getElementById('twitter');
            tweet.addEventListener('click', shareOnTwitter);

        })	
        

        function shareOnFacebook() {	

          const navUrl =
            'https://www.facebook.com/sharer/sharer.php?u=' +
            window.location.href;
          window.open(navUrl, '_blank');
        }

        function shareOnTwitter() {
          const navUrl =
            'https://twitter.com/intent/tweet?text=' +
            window.location.href;
          window.open(navUrl, '_blank');
        }
        
    }
	
	

});



	
